import { API_URL } from 'api/constants';

export const { MOKA_SERVICE_HOST } = process.env;

export const GET_SUBSCRIPTION_STATUS = `${API_URL}/v1/feature/get_subscription_status`;
export const GET_FEATURE_PRICE_PER_MONTHS = `${API_URL}/v1/feature/get_feature_price_per_months`;
export const GET_FEATURE_PRICE_PER_MONTHS_FROM_SERVICE = `${MOKA_SERVICE_HOST}/business-service/v1/feature/feature-price-per-months`;
export const GET_FEATURE_PRICE = `${API_URL}/v1/billings/feature_price`;
export const END_TUTORIAL = `${API_URL}/v1/feature/finish_tutorial`;
export const ACTIVATE_TRIAL = `${API_URL}/v1/feature/activate_trial`;
